export type ReplicaUnique = {
  name: string;
  baseType: string;
  dustValue: number;
  cells: number;
};

export type ReplicaSortKey = "dustValue" | "dustPerCell";
export type SortDirection = "asc" | "desc";

export const INVENTORY_CELL_CAPACITY = 120;
export const DUST_GOAL = 10_000_000;

export type InventoryTotals = {
  cellsUsed: number;
  dustTotal: number;
  cellsRemaining: number;
  requiredDustPerCell: number | null;
  goalReached: boolean;
};

// ilvl 84, 20%-quality dust values from poe-disenchant-tool's public dust
// data. The cell count is item-specific, so differently sized shields and
// weapons are represented correctly rather than inferred from item class.
export const REPLICA_UNIQUES: ReplicaUnique[] = [
  { name: "Replica Shroud of the Lightless", baseType: "Carnal Armour", dustValue: 2771230, cells: 6 },
  { name: "Replica Kongor's Undying Rage", baseType: "Terror Maul", dustValue: 2462215, cells: 8 },
  { name: "Replica Duskdawn", baseType: "Maelström Staff", dustValue: 2253265, cells: 8 },
  { name: "Replica Tukohama's Fortress", baseType: "Ebony Tower Shield", dustValue: 2062060, cells: 8 },
  { name: "Replica Headhunter", baseType: "Leather Belt", dustValue: 1108450, cells: 2 },
  { name: "Replica Bated Breath", baseType: "Chain Belt", dustValue: 721000, cells: 2 },
  { name: "Replica Farrul's Fur", baseType: "Triumphant Lamellar", dustValue: 653030, cells: 6 },
  { name: "Replica Nebulis", baseType: "Void Sceptre", dustValue: 634025, cells: 6 },
  { name: "Replica Windripper", baseType: "Imperial Bow", dustValue: 597625, cells: 8 },
  { name: "Replica Eternity Shroud", baseType: "Blood Raiment", dustValue: 994680, cells: 6 },
  { name: "Replica Atziri's Acuity", baseType: "Vaal Gauntlets", dustValue: 546910, cells: 4 },
  { name: "Replica Alberon's Warpath", baseType: "Soldier Boots", dustValue: 361585, cells: 4 },
  { name: "Replica Maloney's Mechanism", baseType: "Ornate Quiver", dustValue: 321265, cells: 6 },
  { name: "Replica Trypanon", baseType: "Great Mallet", dustValue: 277130, cells: 8 },
  { name: "Replica Kaom's Heart", baseType: "Glorious Plate", dustValue: 152180, cells: 6 },
  { name: "Replica Red Trail", baseType: "Titan Greaves", dustValue: 152180, cells: 4 },
  { name: "Replica Paradoxica", baseType: "Vaal Rapier", dustValue: 143430, cells: 4 },
  { name: "Replica Allure", baseType: "Vaal Claw", dustValue: 143430, cells: 4 },
  { name: "Replica Perfect Form", baseType: "Zodiac Leather", dustValue: 139265, cells: 6 },
  { name: "Replica Hyrri's Ire", baseType: "Zodiac Leather", dustValue: 139265, cells: 6 },
  { name: "Replica Loreweave", baseType: "Elegant Ringmail", dustValue: 135205, cells: 6 },
  { name: "Replica Stampede", baseType: "Assassin's Boots", dustValue: 131250, cells: 4 },
  { name: "Replica Cold Iron Point", baseType: "Ezomyte Dagger", dustValue: 127435, cells: 3 },
  { name: "Replica Tulfall", baseType: "Opal Wand", dustValue: 127435, cells: 3 },
  { name: "Replica Abyssus", baseType: "Ezomyte Burgonet", dustValue: 120120, cells: 4 },
  { name: "Replica Mistwall", baseType: "Lacquered Buckler", dustValue: 120120, cells: 4 },
  { name: "Replica Frostbreath", baseType: "Ornate Mace", dustValue: 89390, cells: 6 },
  { name: "Replica Covenant", baseType: "Spidersilk Robe", dustValue: 86765, cells: 6 },
  { name: "Replica Soul Strike", baseType: "Spike-Point Arrow Quiver", dustValue: 66500, cells: 6 },
  { name: "Replica Midnight Bargain", baseType: "Engraved Wand", dustValue: 66500, cells: 3 },
  { name: "Replica Restless Ward", baseType: "Carnal Armour", dustValue: 55440, cells: 6 },
  { name: "Replica Voidwalker", baseType: "Murder Boots", dustValue: 70918, cells: 4 },
  { name: "Replica Oro's Sacrifice", baseType: "Infernal Sword", dustValue: 49245, cells: 8 },
  { name: "Replica Dreamfeather", baseType: "Eternal Sword", dustValue: 47810, cells: 6 },
  { name: "Replica Alpha's Howl", baseType: "Sinner Tricorne", dustValue: 45080, cells: 4 },
  { name: "Replica Wings of Entropy", baseType: "Ezomyte Axe", dustValue: 42490, cells: 8 },
  { name: "Replica Inya's Epiphany", baseType: "Arcanist Slippers", dustValue: 41230, cells: 4 },
  { name: "Replica Grip of the Council", baseType: "Arcanist Gloves", dustValue: 40040, cells: 4 },
  { name: "Replica Soul Tether", baseType: "Cloth Belt", dustValue: 36820, cells: 2 },
  { name: "Replica Ungil's Gauche", baseType: "Boot Knife", dustValue: 36820, cells: 3 },
  { name: "Replica Badge of the Brotherhood", baseType: "Turquoise Amulet", dustValue: 36820, cells: 1 },
  { name: "Replica Dragonfang's Flight", baseType: "Onyx Amulet", dustValue: 35560, cells: 1 },
  { name: "Replica Three-step Assault", baseType: "Shagreen Boots", dustValue: 34545, cells: 4 },
  { name: "Replica Emberwake", baseType: "Ruby Ring", dustValue: 32725, cells: 1 },
  { name: "Replica Infractem", baseType: "Decimation Bow", dustValue: 32550, cells: 8 },
  { name: "Replica Victario's Charity", baseType: "Laminated Kite Shield", dustValue: 29785, cells: 6 },
  { name: "Replica Heartbreaker", baseType: "Royal Skean", dustValue: 29785, cells: 3 },
  { name: "Replica Siegebreaker", baseType: "Heavy Belt", dustValue: 27405, cells: 2 },
  { name: "Replica Kalisa's Grace", baseType: "Samite Gloves", dustValue: 27265, cells: 4 },
  { name: "Replica Innsbury Edge", baseType: "Elder Sword", dustValue: 27265, cells: 6 },
  { name: "Replica Malachai's Artifice", baseType: "Unset Ring", dustValue: 25690, cells: 1 },
  { name: "Replica Voideye", baseType: "Unset Ring", dustValue: 25690, cells: 1 },
  { name: "Replica Hyrri's Truth", baseType: "Jade Amulet", dustValue: 25060, cells: 1 },
  { name: "Replica Hinekora's Sight", baseType: "Onyx Amulet", dustValue: 24955, cells: 1 },
  { name: "Replica Volkuur's Guidance", baseType: "Zealot Gloves", dustValue: 24220, cells: 4 },
  { name: "Replica Allelopathy", baseType: "Satin Gloves", dustValue: 22820, cells: 4 },
  { name: "Replica Atziri's Foible", baseType: "Paua Amulet", dustValue: 22295, cells: 1 },
  { name: "Replica Harvest", baseType: "Jasper Chopper", dustValue: 20300, cells: 8 },
  { name: "Replica Soul Taker", baseType: "Siege Axe", dustValue: 19425, cells: 6 },
  { name: "Replica Earendel's Embrace", baseType: "Grinning Fetish", dustValue: 19110, cells: 6 },
  { name: "Replica Iron Commander", baseType: "Death Bow", dustValue: 17500, cells: 8 },
  { name: "Replica Advancing Fortress", baseType: "Gut Ripper", dustValue: 16555, cells: 4 },
  { name: "Replica Lioneye's Paws", baseType: "Bronzescale Boots", dustValue: 16485, cells: 4 },
  { name: "Replica Forbidden Shako", baseType: "Great Crown", dustValue: 16275, cells: 4 },
  { name: "Replica Ambu's Charge", baseType: "Crusader Chainmail", dustValue: 15155, cells: 6 },
  { name: "Replica Bones of Ullr", baseType: "Silk Slippers", dustValue: 13020, cells: 4 },
  { name: "Replica Tempestuous Steel", baseType: "War Sword", dustValue: 12285, cells: 6 },
  { name: "Replica Heatshiver", baseType: "Leather Hood", dustValue: 12285, cells: 4 },
  { name: "Replica Bitterdream", baseType: "Shadow Sceptre", dustValue: 10955, cells: 6 },
  { name: "Replica Winterheart", baseType: "Gold Amulet", dustValue: 10605, cells: 1 },
  { name: "Replica Twyzel", baseType: "Sage Wand", dustValue: 10325, cells: 3 },
  { name: "Replica Leer Cast", baseType: "Festival Mask", dustValue: 9730, cells: 4 },
  { name: "Replica Tasalio's Sign", baseType: "Sapphire Ring", dustValue: 8610, cells: 1 },
  { name: "Replica Karui Ward", baseType: "Jade Amulet", dustValue: 8365, cells: 1 },
  { name: "Replica Veil of the Night", baseType: "Great Helmet", dustValue: 8155, cells: 4 },
  { name: "Replica Doedre's Damning", baseType: "Paua Ring", dustValue: 7875, cells: 1 },
  { name: "Replica Bloodplay", baseType: "Stiletto", dustValue: 6615, cells: 3 },
  { name: "Replica Quill Rain", baseType: "Short Bow", dustValue: 4935, cells: 6 },
  { name: "Replica Blood Thorn", baseType: "Gnarled Branch", dustValue: 4795, cells: 4 },
  { name: "Replica Fencoil", baseType: "Gnarled Branch", dustValue: 4795, cells: 4 },
  { name: "Replica Last Resort", baseType: "Nailed Fist", dustValue: 4655, cells: 4 },
  { name: "Replica Prismweave", baseType: "Rustic Sash", dustValue: 4515, cells: 2 },
  { name: "Replica Gifts from Above", baseType: "Diamond Ring", dustValue: 9730, cells: 1 },
  { name: "Replica Maata's Teaching", baseType: "Karui Sceptre", dustValue: 106715, cells: 6 },
];

export function dustPerCell(item: ReplicaUnique): number {
  return item.dustValue / item.cells;
}

export function calculateInventoryTotals(
  items: readonly ReplicaUnique[],
  quantities: Readonly<Record<string, number>>
): InventoryTotals {
  let cellsUsed = 0;
  let dustTotal = 0;

  for (const item of items) {
    const quantity = quantities[item.name] ?? 0;
    const safeQuantity = Number.isFinite(quantity)
      ? Math.max(0, Math.floor(quantity))
      : 0;
    cellsUsed += safeQuantity * item.cells;
    dustTotal += safeQuantity * item.dustValue;
  }

  const cellsRemaining = Math.max(0, INVENTORY_CELL_CAPACITY - cellsUsed);
  const goalReached = dustTotal >= DUST_GOAL;
  const requiredDustPerCell = goalReached
    ? 0
    : cellsRemaining > 0
      ? (DUST_GOAL - dustTotal) / cellsRemaining
      : null;

  return {
    cellsUsed,
    dustTotal,
    cellsRemaining,
    requiredDustPerCell,
    goalReached,
  };
}

export function meetsRequiredDustPerCell(
  item: ReplicaUnique,
  requiredDustPerCell: number | null
): boolean {
  return requiredDustPerCell !== null && dustPerCell(item) >= requiredDustPerCell;
}

export function parseFoundCounts(
  serialized: string | null
): Record<string, string> {
  if (serialized === null) return {};

  try {
    const values: unknown = JSON.parse(serialized);
    if (values === null || typeof values !== "object" || Array.isArray(values)) {
      return {};
    }

    const counts: Record<string, string> = {};
    for (const item of REPLICA_UNIQUES) {
      const rawCount = (values as Record<string, unknown>)[item.name];
      const count =
        typeof rawCount === "number"
          ? rawCount
          : typeof rawCount === "string" && /^\d+$/.test(rawCount)
            ? Number(rawCount)
            : 0;
      if (Number.isSafeInteger(count) && count > 0) {
        counts[item.name] = String(count);
      }
    }
    return counts;
  } catch {
    return {};
  }
}

export function serializeFoundCounts(
  values: Readonly<Record<string, string>>
): string | null {
  const counts: Record<string, number> = {};
  for (const item of REPLICA_UNIQUES) {
    const rawCount = values[item.name];
    if (rawCount === undefined || !/^\d+$/.test(rawCount)) continue;
    const count = Number(rawCount);
    if (Number.isSafeInteger(count) && count > 0) {
      counts[item.name] = count;
    }
  }
  return Object.keys(counts).length > 0 ? JSON.stringify(counts) : null;
}

export function sortReplicaUniques(
  items: readonly ReplicaUnique[],
  key: ReplicaSortKey,
  direction: SortDirection = "desc"
): ReplicaUnique[] {
  return [...items].sort((a, b) => {
    const difference =
      key === "dustValue"
        ? a.dustValue - b.dustValue
        : dustPerCell(a) - dustPerCell(b);
    if (difference !== 0) {
      return direction === "asc" ? difference : -difference;
    }
    return a.name.localeCompare(b.name);
  });
}
